import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Thanks from './pages/thanks/Thanks';
import Waitlist from './pages/waitlist/Waitlist';
import Home from './pages/home/Home';



function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/thanks'element = {<Thanks />} />
      {/* <Route path='/waitlist'element = {<Waitlist />} /> */}
    </Routes>
    </BrowserRouter>
  );
}

export default App;
